export default __webpack_public_path__ + "images/cacc4ebcad69f944b8a5bd1f495d7982-cc-mini-front@2x.png";